/**
 * Which built page is allowed to run its own script.
 *
 * Every other `.html` the workspace route serves goes out under `content-security-policy: sandbox`,
 * and that is what keeps a page the agent assembled from a job posting, a fetched article or an
 * upload away from this app's origin and its cookie. A teaching lesson wants the opposite: a quiz
 * that grades nothing and a simulator that cannot move are the two things such a page exists to be.
 *
 * So the permission rides on the artefact's name rather than on the request. No query parameter and
 * no caller can turn it on, and a page reaches this name only through a build that checked what is
 * in it. The route tests the *real* path, so a symlink cannot borrow the name for another file.
 *
 * Widening the sandbox is not widening the origin: the page is served `allow-scripts` without
 * `allow-same-origin`, so it keeps an opaque origin, and `default-src 'none'` leaves it nothing to
 * talk to. It runs its own code and reaches nothing.
 */
export const SCRIPTED_SUFFIX = ".lesson.html";

/** True when `p` names a page that may run its own inline script. */
export function isScriptedPage(p: string): boolean {
	return p.toLowerCase().endsWith(SCRIPTED_SUFFIX);
}
